// Keep the measured field unchanged; adapt only screen sampling quality.
export function createVolumeQuality(coarse=false) {
    let level=0,previous=0,wasMoving=false,slow=0,lastInterval=0;
    return {
        update(now,moving) {
            const elapsed=now-previous;previous=now;
            if(moving&&wasMoving&&elapsed>0&&elapsed<500) {
                lastInterval=elapsed;
                slow=elapsed>55?slow+1:Math.max(0,slow-1);
                if(slow>=3&&level<2){level++;slow=0;}
            } else slow=0;
            wasMoving=moving;
            const steps=(coarse?[48,32,24]:[64,48,32])[level];
            const width=(coarse?[560,440,360]:[800,640,480])[level];
            const scale=(coarse?[.45,.35,.28]:[.50,.42,.32])[level];
            return {steps:moving?Math.max(16,Math.round(steps/2)):steps,width:moving?Math.round(width*.75):width,scale:moving?scale*.75:scale,level,interval:lastInterval};
        }
    };
}
